import { render, staticRenderFns } from "./CeisaBarangImporEntitas.vue?vue&type=template&id=4b47df84&"
import script from "./CeisaBarangImporEntitas.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporEntitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports